export default __webpack_public_path__ + "static/media/Podium.27efd7cb.svg";